export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";

export const ON_LOGIN = "ON_LOGIN";
export const ON_LOGIN_PENDING = ON_LOGIN + "_PENDING";
export const ON_LOGIN_REJECTED = ON_LOGIN + "_REJECTED";
export const ON_LOGIN_FULFILLED = ON_LOGIN + "_FULFILLED";

export const REGISTER = "REGISTER";
export const CLEAR_REGISTER_DATA = "CLEAR_REGISTER_DATA";
